
function getEnv() {
    if (window.location.hostname === "customers.eventials.com") {
        return "production";
    } else if (window.location.hostname.includes("stg") || window.location.hostname.includes("staging")) {
        return "staging";
    } else if (window.location.hostname.includes("localhost") || window.location.hostname.includes("127.0.0.1") || window.location.hostname.includes("local.eventials.com")) {
        return "staging";
    } else {
        return "production";
    }
}

function getAPIUrl(ENV) {
    switch(ENV.toLowerCase()) {
        case 'production': return 'https://app.eventials.com';
        case 'staging': return 'https://staging.eventials.com';
        case 'local': return 'https://local.eventials.com';
        default: return 'https://eventials.com';
    }
}

function getWLURL(ENV) {
    switch(ENV.toLowerCase()) {
        case 'production': return 'https://customers.eventials.com';
        case 'staging': return 'https://stg-customers.eventials.com';
        case 'local': return 'http://localhost:3000/';
        default: return 'https://eventials.com';
    }
}

function getWLEventURL(ENV) {
    switch(ENV.toLowerCase()) {
        case 'production': return 'https://whitelabel.eventials.com';
        case 'staging': return 'https://stg-whitelabel.eventials.com';
        case 'local': return 'http://localhost:3000/';
        default: return 'https://eventials.com';
    }
}

function getEmbedURL(ENV) {
    switch(ENV.toLowerCase()) {
        case 'production': return 'https://embed.eventials.com/';
        case 'staging': return 'https://staging.eventials.com/';
        case 'local': return 'https://staging.eventials.com/';
        default: return 'https://eventials.com';
    }
}

function getUploadUrl(ENV) {
    switch(ENV.toLowerCase()) {
        case 'production': return 'https://upload-assets.eventials.com/assets/';
        case 'staging': return 'https://upload-assets-stg.eventials.com/assets/';
        case 'local': return 'https://upload-assets-stg.eventials.com/assets/';
        default: return 'https://eventials.com';
    }
}

function getMediaStreamLiveVodDomain(ENV) {
    switch(ENV.toLowerCase()) {
        case 'production': return 'ondemand.eventials.com';
        case 'staging': return 'livevod-cdn-stg.eventials.com';
        case 'local': return 'livevod-cdn-stg.eventials.com';
        default: return 'ondemand.eventials.com';
    }
}

function getMediaStreamVodCdnDomain(ENV) {
    switch(ENV.toLowerCase()) {
        case 'production': return 'ondemand.eventials.com';
        case 'staging': return 'ondemand.eventials.com';
        case 'local': return 'ondemand.eventials.com';
        default: return 'ondemand.eventials.com';
    }
}

function getElementalVodUrl(ENV) {
    switch(ENV.toLowerCase()) {
        case 'production': return "https://vod.eventials.com/";
        case 'staging': return "https://stg-vod.eventials.com/";
        case 'local': return "https://stg-vod.eventials.com/";
        default: return "https://vod.eventials.com/";
    }
}

function getLiveEgressUrl(ENV) {
    switch(ENV.toLowerCase()) {
        case 'production': return "https://egress.eventials.com/";
        case 'staging': return "https://stg-egress.eventials.com/";
        case 'local': return "https://stg-egress.eventials.com/";
        default: return "https://egress.eventials.com/";
    }
}

function getWebScoketUrl(ENV) {
    switch(ENV.toLowerCase()) {
        case 'production': return "wss://websocket.eventials.com";
        case 'staging': return "wss://websocket.eventials.com";
        case 'local': return "wss://websocket.eventials.com";
        default: return "wss://websocket.eventials.com";
    }
}

function getEvWebscoket(ENV) {
    switch(ENV.toLowerCase()) {
        case 'production': return "https://static.eventials.com/evWebSocket/assets/WsApi.d0cc17fd8879851833f7.js";
        case 'staging': return "https://static-stg.eventials.com/evWebSocket/assets/WsApi.d0cc17fd8879851833f7.js";
        case 'local': return "https://static-stg.eventials.com/evWebSocket/assets/WsApi.d0cc17fd8879851833f7.js";
        default: return "https://static.eventials.com/evWebSocket/assets/WsApi.d0cc17fd8879851833f7.js";
    }
}

function getPostMetricsUrl(ENV) {
    switch(ENV.toLowerCase()) {
        case 'production': return "https://analytics.eventials.com/api/player";
        case 'staging': return "https://analytics-stg.eventials.com/api/player";
        case 'local': return "https://analytics-stg.eventials.com/api/player";
        default: return "https://analytics.eventials.com/api/player";
    }
}


const ENV = getEnv();
const API_URL = getAPIUrl(ENV);
const DOMAIN_URL = API_URL;
const WL_URL = getWLURL(ENV);
const WL_EVENT_URL = getWLEventURL(ENV);
const EMBED_URL = getEmbedURL(ENV);
const UPLOAD_URL = getUploadUrl(ENV);

const MEDIA_STREAM_LIVE_VOD_DOMAIN = getMediaStreamLiveVodDomain(ENV);
const MEDIA_STREAM_VOD_CDN_DOMAIN = getMediaStreamVodCdnDomain(ENV);
const ELEMENTAL_VOD_URL = getElementalVodUrl(ENV);
const LIVE_EGRESS_URL = getLiveEgressUrl(ENV);
const MEDIA_STREAM_LIVE_VOD_ORIGIN_APP_NAME = "live";
const MEDIA_STREAM_VOD_ORIGIN_APP_NAME = ENV.toLowerCase() === "production" ? "vod_drm" : "vod";

const WEBSOCKET_URL = getWebScoketUrl(ENV);
const EVWEBSOCKET_URL = getEvWebscoket(ENV);

const URL_POST_METRICS = getPostMetricsUrl(ENV);

export {
    DOMAIN_URL, 
    ENV, API_URL, 
    WL_URL, 
    WL_EVENT_URL, 
    EMBED_URL, 
    UPLOAD_URL,
    MEDIA_STREAM_LIVE_VOD_DOMAIN,
    MEDIA_STREAM_LIVE_VOD_ORIGIN_APP_NAME,
    ELEMENTAL_VOD_URL,
    MEDIA_STREAM_VOD_CDN_DOMAIN,
    MEDIA_STREAM_VOD_ORIGIN_APP_NAME,
    LIVE_EGRESS_URL,
    WEBSOCKET_URL,
    EVWEBSOCKET_URL,
    URL_POST_METRICS,
}
